import React, { useState, useEffect } from 'react'
import { useSessionStorage } from 'usehooks-ts'
import { validateEmail } from 'sdk/utils/validation'
import useCheckIfUserExists from 'sdk/hooks/user/useCheckIfUserExists'
import Button from 'components/shared/Button';
import { Input } from 'components/shared/Input';
import TermsOfUseLinks from 'components/shared/TermsOfUseLinks';
import MessageModal from 'components/shared/modals/MessageModal';
import { StringConstant } from 'utils/Constants';
import SignInLink from './SignInLink';
import styles from './SignUp.module.scss';

type EmailViewProps = {
  email: string,
  setEmail: (v: string) => void,
  handleNext: () => void,
  goToSignIn: () => void,
  className?: string,
}

function EmailView({
  email,
  setEmail,
  handleNext,
  goToSignIn,
  className,
}: EmailViewProps) {
  const [emailError, setEmailError] = useState<boolean>(false)
  const [error, setError] = useState<string>('')
  const [, setDefaultEmail] = useSessionStorage<any>('defaultEmail', null)

  const {
    mutate: getAccounts,
    data: getAccountsData,
    isSuccess: isGetAccountsSuccess,
    isError: isGetAccountsError,
    error: getAccountsError,
    reset: resetGetAccounts,
    isLoading: isGetAccountsLoading,
  } = useCheckIfUserExists({ email: email.toLowerCase() })

  const isValidEmailDomen = (value: string) => {
    if (!value.includes('@') || !value.includes('.')) {
      return true
    }
    // @ts-ignore
    if (value.split('.').length > 1 && value.split('.').at(-1)?.length < 8) {
      return true
    }
    return false
  }

  const handleEmailChange = (e: React.FormEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement
    const value = target?.value
    const regexp = /[а-яё]/i;

    if (regexp.test(value)) {
      setError('Enter latin characters')
      return
    }

    if (isValidEmailDomen(value)) {
      setEmailError(false)
      setError('')
      setEmail(value)
    }
  }

  useEffect(() => {
    if (isGetAccountsError) {
      setError(StringConstant.SIGN_UP_ERROR_MEESAGE)
    }
  }, [isGetAccountsError])

  useEffect(() => {
    if (isGetAccountsSuccess) {
      if (!getAccountsData) {
        handleNext()
        // resetGetAccounts();
      } else if (getAccountsData !== 'deleted') {
        // setError('Seems like you have an account')
        setDefaultEmail(email)
        goToSignIn()
      }
    }
  }, [isGetAccountsSuccess, getAccountsData])

  const isEmailValid = validateEmail(email)
  // @ts-ignore
  if (getAccountsData === 'deleted') {
    return (
      <MessageModal
        title="Error"
        status="sorry"
        // @ts-ignore
        onClick={() => resetGetAccounts()}
        message="Sorry! This account has been deleted. Please reach out to us to initiate the account reactivation process"
      />
    )
  }

  return (
    <div className={className}>
      <Input
        type="email"
        value={email}
        onChange={handleEmailChange}
        placeholder="Enter your email"
        maxLength={320}
        error={emailError || Boolean(error)}
        errorMessage={emailError ? 'Check the correctness of your signup data' : error}
        onBlur={() => setEmailError(!isEmailValid)}
        white
        wide
      />

      <Button
        className={styles.margin20}
        disabled={!isEmailValid || isGetAccountsLoading}
        onClick={() => getAccounts()}
        loading={isGetAccountsLoading}
        purple
        wide
      >
        Next
      </Button>

      <div className={styles.panelFooter}>
        <SignInLink onClick={goToSignIn} />

        <TermsOfUseLinks />
      </div>
    </div>
  )
}

export default EmailView
